<template>
  
  <!-- access -->
  <div class="row wrap">
      <p class="tag" :title="item.desc" @click="update(item.id, access[item.id] ? false : true)" :class="{active: access[item.id]}" v-for="(item, index) in sortlist" :key="index">{{ item.title }}</p>      
  </div>
  
  <!-- roots access -->
  <div class="row wrap" style="margin-top: 20px;" v-if="!access.cat">
      <p class="tag" :title="item.desc" @click="update(item.id, access[item.id] ? false : true)" :class="{active: access[item.id]}" v-for="(item, index) in roots" :key="index">{{ item.title }}</p>      
  </div>
    
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {  
  //    
  },
  props:{
    access: {}
  },

  data() {
    return {
      list: [
          {id: 'news', title: 'News', desc:'Can create and edit news'},
          {id: 'assets', title: 'Assets', desc:'Can create and edit assets'},
          {id: 'users', title: 'Accounts', desc:'Can create and edit accounts'},
          {id: 'api', title: 'API', desc:'Can create and edit api keys'},
          {id: 'team', title: 'Team', desc:'Can create and edit team members'},
          {id: 'doc', title: 'Docs', desc:'Can create and edit docs'},
          {id: 'support', title: 'Support', desc:'Support member. Answer tickets etc'},
          {id: 'tasks', title: 'Tasks', desc:'Can create and edit tasks'},        
          {id: 'cat', title: 'Categories', desc:'Can create and edit all assets categories'},
          {id: 'dict', title: 'Dicts', desc:'Can create and edit assets dicts'},
          {id: 'attr', title: 'Attributes', desc:'Can create and edit assets attributes'},
          {id: 'stats', title: 'Stats', desc:'Get stima stats'},
          {id: 'notify', title: 'Notify', desc:'Create and send user notify'},
          {id: 'servers', title: 'Servers', desc:'Server monitoring etc'},
          {id: 'charts', title: 'Charts', desc:'Create and push assets charts/indexes'},
        ]
    }
  },
  computed: {
    sortlist(){
      let list = this.list
      list.sort((a, b) => a.title.localeCompare(b.title))
      return list
    },
    roots(){        
        let list = []        
        let roots = this.roots.all
        if (!roots) return []
        roots.forEach(p => {
          list.push({id: p.sid, title: p.title, desc:'Can create and edit this category'})
        });
        list.sort((a, b) => a.title.localeCompare(b.title))
        return list
    },
  },
  
  methods: {
    
   
    // create user
    async update(key, value){
      this.$emit('update', {key, value})
    },
    
    
  },
});

</script>
<style scoped>
body{
  overflow-y: scroll ;
}
.subtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
  letter-spacing: 0.0em;
  color: var(--g4);
  margin: 10px 0;
  /* margin-left: -5px; */

}

.tabs {
  margin: 0 10px;
}

.tableimage{
  width: 20px;
  height: 20px;
  background: none;
  border: 1px solid var(--g2);
  border-radius: 100px;
}

.jsonpre{
  font-family: monospace;
  font-size: 11px;
  line-height: 15px;
}

</style>